module.exports = __webpack_public_path__ + "img/symbol_8.e4ed94aa.png";